// FT-482: append-only merge for voyage unifiedLog arrays.
// When cloud wins a voyage in mergePullDelta(), locally-written log entries
// (not yet pushed) must survive the pull. Same-id entries → cloud wins.
export function mergeUnifiedLogs(localLog, cloudLog) {
  const local = Array.isArray(localLog) ? localLog : [];
  const cloud = Array.isArray(cloudLog) ? cloudLog : [];

  // Build map from cloud entries (cloud is the base)
  const merged = new Map();
  for (const entry of cloud) {
    if (entry && entry.id) merged.set(entry.id, entry);
  }
  // Add local-only entries (those not already in cloud by id)
  for (const entry of local) {
    if (entry && entry.id && !merged.has(entry.id)) {
      merged.set(entry.id, entry);
    }
  }
  return Array.from(merged.values());
}
